'use strict';

const initialState = {};

function emptyReducer(state = initialState, action) {
    return state;
}

export { emptyReducer };

export default {
    emptyReducer: emptyReducer
};
